import Base from './base'

export const CRM_OBJECT_TYPE_OPPORTUNITY = 'Opportunity'

export default class Crm extends Base {
  getActivityFields(params: { source: string }) {
    return this.api.get('crm_activity_fields', { params })
  }

  refreshCrmObject(crmId: string) {
    return this.api.post('refresh_crm_object', {
      crm_id: crmId,
      crm_object_type: CRM_OBJECT_TYPE_OPPORTUNITY,
    })
  }
}
